import { Component, OnInit, ViewChild } from "@angular/core";

import { Router } from "@angular/router";
import { MatInput } from "@angular/material";
import serverConfigInfo from "../../../../../../Server/config.json";
import { VernostServiceService } from "../../../../services/vernost-service.service";
import { saveAs } from "file-saver";
import { DatePipe } from "@angular/common";
import { CommonService } from "../../../../services/common.service";
@Component({
  selector: "app-ftr",
  templateUrl: "./ftr.component.html",
  styleUrls: ["./ftr.component.css"],
  providers: [DatePipe]
})
export class FTRComponent implements OnInit {
  @ViewChild("input", { read: MatInput }) input: MatInput;
  @ViewChild("input2", { read: MatInput }) input2: MatInput;
  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;
  @ViewChild("input9", { read: MatInput }) input9: MatInput;
  Gdate;
  from;
  to;
  sdate;
  final;
  screentitle: string = "FTR";
  downd = true;
  mydate = new Date();
  showsingle = true;
  showMultiple = true;
  showsingle1 = true;
  showMultiple1 = true;
  search_result_list1: any = [];
  searchlist: boolean = true;
  journeydate = false;
  invaliddate = false;
  ftr_search_details;
  isFname = false;
  isLname = false;
  tomorrow1;
  isOrd = false;
  isPnr = false;
  disablebtn = true;
  bookingdate = false;
  dateValid = false;
  tomorrow;
  arr: any = [];
  booking_ref: any = "asdasd";
  p: number = 1;
  isPaginationFlow : boolean = false;
  search_result_list: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  existingbooking: boolean = true;
  isAccrual: boolean = false;
  bookinglist: boolean = false;
  booking_details: any = "";
  booking_details_info: any = [];
  segment_details: any = "";
  pax_detail: any = "";
  loader: any = false;
  uid;
  cancelbtn;
  BOOKING_STATUS;
  ftr_cancelHistory: any = [];
  ftr_isCancelOpen: boolean = false;
  ftr_isJpNumber: boolean = false;
  ftr_noresult: any = "";
  ftr_booking_status: any = [
    { key: 1, value: "Pending" },
    { key: 2, value: "Booked" },
    { key: 4, value: "Failed" },
    { key: 12, value: "Rescheduled" }
  ];
  ftr_aff_partner: any = []
  ftr_newDate: any = new Date();
  ftr_myDate: any = new Date();
  ftr_totalItems: number = 1;
  ftr_typeOfRedemption: any = "A";
  ftr_typeOfRedem: any = "A";
  initialPageCount: number = 1;
  ftr_ancillary_bkg_status_map = [
    // {"key":"undefined", "value": "Not Opted"},
    { "key": 1, "value": "Not Opted" },
    { "key": 0, "value": "Pending" },
    { "key": 2, "value": "Confirmed" },
    { "key": 4, "value": "Failed" },
    { "key": 5, "value": "Cancelled" },
    { "key": 6, "value": "Reversed" }
  ]
  ftr_ancillary_type_map = [
    { "key": 1, "value": "Meal" },
    { "key": 2, "value": "Baggage" },
    { "key": 3, "value": "Seat" },
    { "key": 0, "value": "Travel Insurance" }
  ]
  ftr_ancillary_type_map_req = {
    "1": "Meal",
    "2": "Baggage",
    "3": "Seat",
    "0": "Travel Insurance"
  }
  ftr_ancillary_bkg_status_map_req = {
    // {"key":"undefined", "value": "Not Opted"},
    "1": "Not Opted",
    "0": "Pending",
    "2": "Confirmed",
    "4": "Failed",
    "5": "Cancelled",
    "6": "Reversed"
  }
  constructor(
    private vernostService: VernostServiceService,
    private commonService: CommonService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.ftr_isJpNumber = false;
    this.cancelbtn = true;
    this.ftr_isCancelOpen = false;
    this.uid = localStorage.getItem("uid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    for(let item of serverConfigInfo.affliatepartner.partners){
      this.ftr_aff_partner.push({key: item, value: item});
    }
    this.ftr_search_details = {
      jp_number: "",
      order_id: "",
      first_name: "",
      last_name: "",
      airlinepnr: "",
      status: "E",
      aff_partner: "E",
      tripdate_from: "",
      tripdate_to: "",
      bookingdate_from: "",
      bookingdate_to: "",
      Ticket_No: "",
      ancillary_status: "",
      ancillary_type: ""
    };
  }

  searchForm() {
    this.existingbooking = true;
    this.bookinglist = false;
    this.initialPageCount = 1;
    this.searchData();
  }
  selectTypeOfRedemption(type) {
    this.ftr_typeOfRedemption = type;
    if(type === 'A'){
      this.isAccrual = true;
    }else{
      this.ftr_search_details.aff_partner = 'E';
      this.isAccrual = false;
    }
  }
  ngAfterContentInit() {
    this.ftr_search_details.bookingdate_to = new Date();
    this.ftr_search_details.bookingdate_from = new Date();
    this.final = this.ftr_search_details.bookingdate_to.setDate(
      this.ftr_search_details.bookingdate_to.getDate()
    );
    this.final = new Date(this.final);
    this.IsEmptyVal = true;
    // this.searchData();
  }
  pageCount(count) {
    // console.log("count------------>",count);
    this.p = count;
    // this.isPaginationFlow = true;
    this.searchData();
  }
  searchData() {
    // console.log("isPaginationFlow------->",this.isPaginationFlow);    
    // if(!this.isPaginationFlow){
    //   this.p = 1;
    // }
    // this.isPaginationFlow = false;
    this.ftr_noresult = "";
    if ( this.ftr_isJpNumber == false && this.isPnr == false && this.isOrd == false && this.isFname == false && this.isLname == false ) {
      this.loader = true;
      this.searchlist = false;
      this.cancelbtn = true;
      this.search_result_list = [];
      this.search_result_list1 = [];
      this.order_Id_list = [];
      this.search_detail_list = [];
      this.toDate();
      var boofrom = this.ftr_search_details.bookingdate_from;
      var bookto = this.ftr_search_details.bookingdate_to;
      var AirLine_Pnr = this.ftr_search_details.airlinepnr;
      var jp_number = "";
      if (this.ftr_typeOfRedemption == "A") {
        jp_number = this.ftr_search_details.jp_number;
      }
      if (this.ftr_typeOfRedemption == "R") {
        jp_number = "00" + this.ftr_search_details.jp_number;
      }

      if ((this.ftr_search_details.tripdate_to == null || this.ftr_search_details.tripdate_to == '')
        && (this.ftr_search_details.tripdate_from != '' || this.ftr_search_details.tripdate_from != null)) {
        this.ftr_search_details.tripdate_to = "";
      }

      if ((this.ftr_search_details.tripdate_from == null || this.ftr_search_details.tripdate_from == '')
        && (this.ftr_search_details.tripdate_to != '' || this.ftr_search_details.tripdate_to != null)) {
        this.ftr_search_details.tripdate_from = "";
      }

      var BOOKING_REF_NO = (this.ftr_search_details.order_id.toString().length <= 15 ? this.ftr_search_details.order_id.slice(4, this.ftr_search_details.order_id.length) : this.ftr_search_details.order_id);
      var data = this.commonData(boofrom, bookto, jp_number, BOOKING_REF_NO, AirLine_Pnr);
      data['pagination'] = this.p;
      data['initialPageCount'] = this.initialPageCount;

      // console.log("data-------------->",data);
      
      this.vernostService.getExistingBooking(data).subscribe(async response => {
        // console.log("this.vernostService.getExistingBooking called",response);
        
        var Data = response;
        this.ftr_typeOfRedem = this.ftr_typeOfRedemption;

        var count = Data[0].count;
        this.initialPageCount = Data[0].count
        this.ftr_totalItems = count;
        this.search_result_list = Data[0].result;
        for (var i = 0; i < this.search_result_list.length; i++) {
          this.search_result_list[i].Booking_Ref = (this.search_result_list[i].Booking_Ref.toString().length < 12 ? "JPUB" + this.search_result_list[i].Booking_Ref : this.search_result_list[i].Booking_Ref);
        }

        var Search_Details = [];
        for (var j = 0; j < this.search_result_list.length; j++) {
          if (
            this.order_Id_list.indexOf(
              this.search_result_list[j].Booking_Ref
            ) == -1
          ) {
            this.order_Id_list.push(this.search_result_list[j].Booking_Ref);
            Search_Details.push(this.search_result_list[j]);
          }
        }
        this.search_detail_list = Search_Details;
        if (
          this.search_detail_list.length == 0 ||
          this.search_detail_list == undefined ||
          this.search_detail_list == ""
        ) {
          this.ftr_noresult = "Result Not Found";
          this.loader = false;

          //document.getElementById("noresulrErr").innerHTML = "Result Not Found";
        } else {
          this.loader = false;
        }
      });
    }
  }
  commonData(boofrom, bookto, jp_number, BOOKING_REF_NO, AirLine_Pnr) {
    var data = {
      booking_fromdate: boofrom,
      booking_todate: bookto,
      jp_number: jp_number,
      order_id: BOOKING_REF_NO,
      first_name: this.ftr_search_details.first_name,
      last_name: this.ftr_search_details.last_name,
      airlinepnr: AirLine_Pnr.toUpperCase(),
      status: this.ftr_search_details.status,
      Ticket_No: this.ftr_search_details.Ticket_No,
      typeOfRedemption: this.ftr_typeOfRedemption,
      from_departure_date: this.ftr_search_details.tripdate_from,
      to_departure_date: this.ftr_search_details.tripdate_to,
      affiliate_partner: this.ftr_search_details.aff_partner
    }

    return data;
  }

  toDate() {
    this.ftr_search_details.bookingdate_from = this.datePipe.transform(
      this.ftr_search_details.bookingdate_from,
      "yyyy-MM-dd"
    );
    this.ftr_search_details.bookingdate_to = this.datePipe.transform(
      this.ftr_search_details.bookingdate_to,
      "yyyy-MM-dd"
    );
    // Todate = this.datePipe.transform(Todate, "yyyy-MM-dd");

    this.ftr_search_details.tripdate_from = this.datePipe.transform(
      this.ftr_search_details.tripdate_from,
      "yyyy-MM-dd"
    );

    this.ftr_search_details.tripdate_to = this.datePipe.transform(
      this.ftr_search_details.tripdate_to,
      "yyyy-MM-dd"
    );
  }

  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }
  book_details(param, type) {
    if (type == "book") {
      this.loader = true;
    }
    let data = {
      booking_ref: param
    };
    this.vernostService.getBookingDetails(data).subscribe(response => {
      this.loader = false;

      this.booking_details_info = response[0].booking[0];
      this.booking_details = response[0].booking;
      this.segment_details = response[0].segment_details;
      this.pax_detail = response[0].pax_detail;
      this.BOOKING_STATUS = this.booking_details.BOOKING_STATUS;
    });

    if (type == "book") {
      this.existingbooking = false;
      this.bookinglist = true;
      this.ftr_isCancelOpen = false;
    } else {
      this.ftr_isCancelOpen = true;

      //this.confirmMessage(this.booking_details.Ticket_No,type);
    }
  }

  cancelBooking(ORDER_ID, type) {
    this.cancelbtn = true;

    var array = {
      FB_BOOKING_REF_NO: this.booking_details_info.Booking_Ref,
      ORDER_ID: this.booking_details_info.ORDER_ID,
      ORIGIN: this.segment_details[0].ORIGIN,
      DESTINATION: this.segment_details[0].DESTINATION,
      TRANSACTION_ID: this.booking_details_info.TRANSACTION_ID,
      TRIP_ID: this.booking_details.TRIP_ID,
      JP_NUMBER: this.booking_details_info.JP_NUMBER,
      PRODUCT_TYPE: this.booking_details_info.ORDER_TYPE,
      TIER: this.booking_details_info.TIER,
      CANCELLED_BY: this.uid,
      CREATED_BY: this.uid
    };

    this.vernostService.cancelHistoryFlightBooking(array).subscribe(response => {
        if (response[0].status == "Success") {
          this.cancelbtn = false;
        }
        if (response[0].status == "failed") {
          this.cancelbtn = true;
        }
      });
    var updateArray = {
      BOOKING_STATUS: 11,
      TRANSACTION_STATUS: "",
      MEMBER_POINT_BALANCE: "",
      ORDER_ID: this.booking_details_info.ORDER_ID,
      FB_BOOKING_REF_NO: this.booking_details_info.Booking_Ref
    };
    this.vernostService.cancelFlightBooking(updateArray).subscribe(response => {

      if (this.ftr_isCancelOpen == true) {
        // this.searchData();
      }
    });
  }

  jpNumberValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.jp_number;
    this.ftr_isJpNumber = this.commonService.validation('jpnumbervalidation', /^[A-Za-z0-9_]+$/, JPNo);
    // if (JPNo.length <= 0) {
    //   this.isJpNumber = true;
    // } else {
    //   this.isJpNumber = false;
    // }
  }

  ticketValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.Ticket_No;
    this.ftr_isJpNumber = this.commonService.validation('ticketvalidation', /^[A-Za-z0-9_]+$/, JPNo);
  }

  jpNumberValidation1() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.jp_number;
    this.ftr_isJpNumber = this.commonService.validation('jpnumbervalidation1', '', JPNo);
  }

  ticketValidation1() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.Ticket_No;
    this.ftr_isJpNumber = this.commonService.validation('ticketvalidation1', '', JPNo);
  }

  fnameValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.first_name;
    this.isFname = this.commonService.validation('fname', /^[A-Za-z]+$/, JPNo);
    // if (JPNo.length <= 0) {
    //   this.isJpNumber = true;
    // } else {
    //   this.isJpNumber = false;
    // }
  }
  lnameValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.last_name;
    this.isLname = this.commonService.validation('fname', /^[A-Za-z]+$/, JPNo);
    // if (JPNo.length <= 0) {
    //   this.isJpNumber = true;
    // } else {
    //   this.isJpNumber = false;
    // }
  }
  orderValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.order_id;
    this.isOrd = this.commonService.validation('orderValidation', /^[A-Za-z0-9_]+$/, JPNo);
    // if (JPNo.length <= 0) {
    //   this.isJpNumber = true;
    // } else {
    //   this.isJpNumber = false;
    // }
  }

  orderValidation1() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.order_id;
    this.isOrd = this.commonService.validation('orderValidation1', '', JPNo);
  }

  pnrValidation1() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.airlinepnr;
    this.isPnr = this.commonService.validation('pnrValidation1', '', JPNo);
  }

  pnrValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_search_details.airlinepnr;
    this.isPnr = this.commonService.validation('pnrValidation', /^[A-Za-z0-9_]+$/, JPNo);
    // if (JPNo.length <= 0) {
    //   this.isJpNumber = true;
    // } else {
    //   this.isJpNumber = false;
    // }
  }

  toggleDisable1() {
    // this.bookingdate = true;

    // if (
    //   this.search_details.tripdate_from.length != "" ||
    //   this.search_details.tripdate_to.length != ""
    // ) {
    //   this.bookingdate = true;
    // } else {
    //   this.bookingdate = false;
    // }
    this.isEmpty();
    // this.search_details.tripdate_from = ''

    if (this.ftr_search_details.tripdate_from.length != "") {
      //   var date = this.search_details.tripdate_from;
      // this.tomorrow = this.search_details.tripdate_from;
      // this.tomorrow = this.tomorrow.getDate() + 1;
      // this.search_details.tripdate_from = this.date.setDate(this.date.getDate() + 1);
    }
  }
  toggleDisable2() {
    // this.journeydate = true;
    this.ftr_search_details.bookingdate_to = "";
    // if (
    //   this.search_details.bookingdate_from.length != "" ||
    //   this.search_details.bookingdate_to.length != ""
    // ) {
    //   this.journeydate = true;
    // } else {
    //   this.journeydate = false;
    // }

    // if (this.search_details.bookingdate_from.length != "") {
    //   // this.tomorrow1 = this.search_details.bookingdate_from;
    //   // this.tomorrow1.setDate(this.tomorrow1.getDate() + 1);
    // }
  }

  IsEmptyVal: boolean = false;
  isEmpty() {
    if (
      this.ftr_search_details.jp_number == "" &&
      this.ftr_search_details.airlinepnr == "" &&
      this.ftr_search_details.order_id == "" &&
      this.ftr_search_details.Ticket_No == "" &&
      this.ftr_search_details.first_name == "" &&
      this.ftr_search_details.last_name == "" &&
      this.ftr_search_details.status == "E" &&
      (this.ftr_search_details.bookingdate_from == "" ||
        this.ftr_search_details.bookingdate_to == "")
      && (this.ftr_search_details.tripdate_from == "" || this.ftr_search_details.tripdate_to == "")
    ) {
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;
    }
  }
  checkempty() {
    // if()
    if (
      this.ftr_search_details.bookingdate_from == "" ||
      this.ftr_search_details.bookingdate_to == ""
    ) {
      this.dateValid = true;
    } else {
      this.dateValid = false;
    }
    if (
      this.ftr_search_details.jp_number.length == 0 &&
      this.ftr_search_details.Ticket_No.length == 0 &&
      this.ftr_search_details.last_name.length == 0 &&
      this.ftr_search_details.first_name.length == 0 &&
      this.ftr_search_details.airlinepnr.length == 0 &&
      this.ftr_search_details.order_id.length == 0 &&
      this.ftr_search_details.status == "E"
    ) {
      this.disablebtn = true;
    }

    if (
      this.ftr_search_details.jp_number.length == 0 &&
      this.ftr_search_details.last_name.length == 0 &&
      this.ftr_search_details.first_name.length == 0 &&
      this.ftr_search_details.airlinepnr.length == 0 &&
      this.ftr_search_details.order_id.length == 0 &&
      this.ftr_search_details.Ticket_No.length == 0 &&
      this.ftr_search_details.status != "E"
    ) {
      this.ftr_isJpNumber = false;
      this.disablebtn = false;
      this.isFname = false;
      this.isLname = false;
      this.isPnr = false;
      this.isOrd = false;
      this.invaliddate = false;
      this.dateValid = false;
    }

    if (
      (this.ftr_search_details.jp_number.length != 0 ||
        this.ftr_search_details.last_name.length != 0 ||
        this.ftr_search_details.Ticket_No.length != 0 ||
        this.ftr_search_details.first_name.length != 0 ||
        this.ftr_search_details.airlinepnr.length != 0 ||
        this.ftr_search_details.order_id.length != 0 ||
        this.ftr_search_details.status != "E") &&
      (this.ftr_search_details.bookingdate_from != "" &&
        this.ftr_search_details.bookingdate_to != "")
    ) {
      this.disablebtn = false;
    }

    if (
      (this.ftr_search_details.jp_number.length != 0 ||
        this.ftr_search_details.last_name.length != 0 ||
        this.ftr_search_details.first_name.length != 0 ||
        this.ftr_search_details.Ticket_No.length != 0 ||
        this.ftr_search_details.airlinepnr.length != 0 ||
        this.ftr_search_details.order_id.length != 0 ||
        this.ftr_search_details.status != "E") &&
      (this.ftr_search_details.bookingdate_from == "" &&
        this.ftr_search_details.bookingdate_to == "")
    ) {
      this.disablebtn = false;
    }

    if (
      this.ftr_search_details.bookingdate_from == "" &&
      this.ftr_search_details.bookingdate_to != ""
    ) {
      this.disablebtn = true;
    }

    if (
      this.ftr_search_details.bookingdate_from != "" &&
      this.ftr_search_details.bookingdate_to == ""
    ) {
      this.disablebtn = true;
    }
  }


  reset(frombtn) {
    if (frombtn == 'reset') {
      this.input9.value = "";
      this.ftr_search_details.tripdate_to = "";
      this.tomorrow = "";
      this.isEmpty();
    }
    if (frombtn == 'reset2') {
      this.input2.value = "";
      this.ftr_search_details.tripdate_from = "";
    }
    if (frombtn == 'reset3') {
      this.input3.value = "";
      this.ftr_search_details.bookingdate_from = "";
      this.tomorrow1 = "";
      this.final = "";
      this.isEmpty();
    }
    if (frombtn == 'reset4') {
      this.input4.value = "";
      this.ftr_search_details.bookingdate_to = "";
      this.isEmpty();
    }
  }

  downloadData(file_name) {
    var fname = file_name + "out.csv";

    this.vernostService.downloadFile(fname).subscribe(
      data => {
        saveAs(data, "FTR.csv");
        this.loader = false;
      },
      err => { }
    );
  }

  getReprt() {
    //req.body.fromdate != "" && req.body.todate
    this.ftr_noresult = "";
    if (
      this.ftr_isJpNumber == false &&
      this.isPnr == false &&
      this.isOrd == false &&
      this.isFname == false &&
      this.isLname == false
    ) {
      this.loader = true;
      this.toDate();
      var boofrom = this.ftr_search_details.bookingdate_from;
      var bookto = this.ftr_search_details.bookingdate_to;
      //document.getElementById("rdiv").innerHTML = "hefrerf";
      var AirLine_Pnr = this.ftr_search_details.airlinepnr;
      var jp_number = "";
      if (this.ftr_typeOfRedemption == "A") {
        jp_number = this.ftr_search_details.jp_number;
      }
      if (this.ftr_typeOfRedemption == "R") {
        jp_number = "00" + this.ftr_search_details.jp_number;
      }

      if ((this.ftr_search_details.tripdate_to == null || this.ftr_search_details.tripdate_to == '') && (this.ftr_search_details.tripdate_from != '' || this.ftr_search_details.tripdate_from != null)) {
        this.ftr_search_details.tripdate_to = this.ftr_search_details.tripdate_from
      }

      if ((this.ftr_search_details.tripdate_from == null || this.ftr_search_details.tripdate_from == '') && (this.ftr_search_details.tripdate_to != '' || this.ftr_search_details.tripdate_to != null)) {
        this.ftr_search_details.tripdate_from = this.ftr_search_details.tripdate_to;
      }

      var BOOKING_REF_NO = (this.ftr_search_details.order_id.toString().length <= 15 ? this.ftr_search_details.order_id.slice(4, this.ftr_search_details.order_id.length) : this.ftr_search_details.order_id);

      var data = this.commonData(boofrom, bookto, jp_number, BOOKING_REF_NO, AirLine_Pnr);

      // departure_date:this.search_details.tripdate_to
      // ancillary_status: (this.search_details.ancillary_status=="")?
      //   "":this.ancillary_bkg_status_map_req[this.search_details.ancillary_status],
      // ancillary_type:  (this.search_details.ancillary_type=="")?
      //   "":this.ancillary_type_map_req[this.search_details.ancillary_type]

      var url = "";
      if (this.ftr_typeOfRedemption == "R") {
        url = "RedeemFTRReport";
      } else {
        url = "AccrualFTRReport";
      }

      this.vernostService.DownloadReports(url, data).subscribe(
        result => {
          this.ftr_noresult = "";
          if (result.size != 0) {
            saveAs(result, "FTR.csv");
          } else {
            this.ftr_noresult = "Result Not Found";
          }
          this.loader = false;
        },
        err => { }
      );
    }
  }
  checkStatus() {
    this.showsingle = true;
    this.showMultiple = true;

    if (
      this.ftr_search_details.tripdate_from == "" &&
      this.ftr_search_details.tripdate_to != ""
    ) {
      this.showMultiple = false;

      this.Gdate = this.ftr_search_details.tripdate_to;
     // document.getElementById("rdiv").innerHTML = "To Date";
    }

    if (
      this.ftr_search_details.tripdate_to == "" &&
      this.ftr_search_details.tripdate_from != ""
    ) {
      this.showMultiple = false;
      this.Gdate = this.ftr_search_details.tripdate_from;

     // document.getElementById("rdiv").innerHTML = "From Date";
    }

    if (
      this.ftr_search_details.tripdate_to != "" &&
      this.ftr_search_details.tripdate_from != ""
    ) {
      this.showsingle = false;

      this.from = this.ftr_search_details.tripdate_from;
      this.to = this.ftr_search_details.tripdate_to;
    }
  }

  incresedate() {
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrow);
    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);
  }

  checkDate() {
    this.invaliddate = false;
    if (
      this.ftr_search_details.bookingdate_to != "" &&
      this.ftr_search_details.bookingdate_to != " " &&
      this.ftr_search_details.bookingdate_to != null
    ) {
      var FromDate = this.ftr_search_details.bookingdate_from;
      FromDate.setDate(FromDate.getDate() - 1);
      if (FromDate >= this.ftr_search_details.bookingdate_to) {
        this.invaliddate = true;
      }
    }
  }
  checkStatus1() {
    this.mydate = this.ftr_search_details.bookingdate_from;
    this.checkempty();
    this.showsingle1 = true;
    this.showMultiple1 = true;

    if (
      this.ftr_search_details.bookingdate_from != "" &&
      this.ftr_search_details.bookingdate_to != ""
    ) {
      this.downd = false;
      //  this.disablebtn = true;
      // this.checkempty();
    } else {
      this.downd = true;
    }
  }
  set_dept_to: any
  setDepartureTo() {

    var today = (document.getElementById('deptfrom') as HTMLInputElement).value;
    var tam = new Date(today);
    this.set_dept_to = tam.setDate(tam.getDate());
    this.set_dept_to = new Date(this.set_dept_to);


  }
}
